import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, Router } from '@angular/router';
import { UserLoginService } from '../service/user-login.service';
import { intersection } from 'lodash';
import { AuthableRole } from '../types';
import { first, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class HasRoleGuard implements CanActivate, CanActivateChild {
  private userService = inject(UserLoginService);
  private router = inject(Router);

  canActivate(route: ActivatedRouteSnapshot) {
    return this.evaluate(route);
  }

  canActivateChild(childRoute: ActivatedRouteSnapshot) {
    return this.canActivate(childRoute);
  }

  evaluate(route: ActivatedRouteSnapshot) {
    return this.userService.currentProfileLoaded$.pipe(first()).pipe(
      map(() => {
        const roles = this.userService.currentProfileRoleList();
        const routeRequiredRoles: AuthableRole[] = route.data.requiredRoles ?? [];

        const matchesRole = intersection(roles, routeRequiredRoles).length > 0;

        if (routeRequiredRoles.length === 0 || matchesRole) {
          return true;
        }

        return this.router.createUrlTree(['home']);
      }),
    );
  }
}
